var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVdcLogoImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "light",
    viewBox: "0 0 158 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24ZM25.7323 12H36.5983L29.2336 21.1757H18.4883L25.7323 12ZM18.4446 21.1758L23.7667 28.2114L29.2703 21.1758H40.2168L27.6373 36.7504H19.8961L7.49805 21.1758H18.4446Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.394 35.7209L91.5073 12.0566L82.1135 12.0566L74.6303 28.5643L66.6695 12.0566H56.416L68.3891 35.7209H80.394Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2116 35.7209H107.057C121.163 35.7527 124.125 29.5822 124.125 24.2068V23.2526C124.125 17.6546 120.686 12.0566 107.025 12.0566H90.2116V35.7209ZM99.2551 18.2589H105.974C113.871 18.2589 114.731 21.6623 114.731 23.7297V23.9206C114.731 25.988 113.839 29.4549 105.974 29.4549H99.2551V18.2589Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M141.064 36.1662C155.361 36.1662 157.559 29.5186 157.559 26.4015V25.8926L148.197 25.8926C148.069 26.4333 147.369 29.773 140.395 29.773C134.026 29.773 132.434 26.4333 132.434 23.8888V23.5071C132.434 20.8671 133.835 17.9727 140.363 17.9727C147.21 17.9727 148.006 20.9943 148.165 21.5987L157.559 21.5987V21.1852C157.527 18.1635 155.489 11.6113 141.064 11.6113H139.822C125.047 11.6113 123.072 18.8315 123.072 23.348V24.2704C123.072 28.7552 125.238 36.1662 139.822 36.1662H141.064Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVdcLogoImg);
export default __webpack_public_path__ + "static/media/vdcLogoImg.e2bd91691151e721f4441796dfd69fe7.svg";
export { ForwardRef as ReactComponent };